import { render, staticRenderFns } from "./AdherenceIndicatorsGraph1.vue?vue&type=template&id=4c67213b&scoped=true&"
import script from "./AdherenceIndicatorsGraph1.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsGraph1.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsGraph1.vue?vue&type=style&index=0&id=4c67213b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67213b",
  null
  
)

export default component.exports